import { Icon } from '@aibees/shared/components';
import { classnames, fHumanReadableNumber } from '@aibees/shared/utils';
import { memo } from 'react';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { VisibilityTabsProps as Props } from './types';

export const VisibilityTabs = memo(
  ({ className, tabValue, counts, onChange, isLoading }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('VisibilityTabs', className)}
        sx={SX.root}
        textColor="primary"
        indicatorColor="primary"
        value={tabValue}
        onChange={onChange}
        variant="fullWidth"
        key={tabValue}
        size="medium"
      >
        {config.map(({ label, value, key }) => (
          <Styled.Tab
            LabelContent={
              isLoading ? (
                <Icon name="loading-right-outline" />
              ) : (
                fHumanReadableNumber(
                  Number(counts?.[key as keyof typeof counts]) || 0
                )
              )
            }
            LabelVariant="soft"
            key={value}
            label={label}
            value={value}
          />
        ))}
      </Styled.Wrapper>
    );
  }
);

VisibilityTabs.displayName = 'VisibilityTabs';
